import { FieldMsgErrorComponent } from './field-msg-error.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [
    FieldMsgErrorComponent,
  ],
  exports: [
    FieldMsgErrorComponent,
  ],
})
export class fieldMsgErrorModule {
}


// WEBPACK FOOTER //
// ./src/app/components/field-msg-error/field-msg-error.module.ts